import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import Logger from '../logger'

const logger = Logger.create('i18n')

i18n
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    ns: ['translations'],
    defaultNS: 'translations',
    nsSeparator: false,
    keySeparator: false,

    interpolation: {
      escapeValue: false, // not needed for React
      formatSeparator: ','
    },

    react: {
      useSuspense: true
    },

    missingKeyHandler: e => {
      if (Math.random() > 1) {
        console.log({ missingKeyHandler: e })
      }
    },

    saveMissing: true
  })
  .then(() => logger.verbose('initialised'))

export default i18n
